import React, { useCallback, useMemo } from "react";
import { faker } from "@faker-js/faker";

const NdrHistory = ({ data = [] }) => {
  const actions = ["NDR Raised", "Reattempt"];

  const dummyData = useMemo(
    () =>
      Array.from({ length: 14 }, (_, index) => {
        const action = actions[Math.floor(Math.random() * actions.length)];
        const by = action === "NDR Raised" ? "Courier" : "Seller";
        const remark =
          by === "Courier"
            ? "Customer not available"
            : "Please deliver it as soon as possible";

        return {
          date: faker.date.recent().toLocaleDateString(),
          action,
          attempt: 14 - index,
          by,
          remark,
        };
      }),
    []
  );

  const headers = ["Date", "Action", "Remark", "Attempt #", "By"];

  const formatDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }, []);

  return (
    <div className="overflow-y-auto w-full">
      <table className="min-w-full bg-secondary/5 border-[1.5px] border-secondary/10 border-collapse">
        <thead>
          <tr className="bg-secondary/10">
            {headers.map((header, index) => (
              <th
                key={header}
                className="py-2 px-4 border-r border-secondary/10 text-subtitle1 text-secondary/70 font-bold font-nunito"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map(
            (
              {
                timestamp: date,
                actionType: action,
                remarks,
                attempt,
                actor: by,
              },
              index
            ) => (
              <tr
                key={index}
                className={
                  index % 2 === 0 ? "bg-secondary/5" : "bg-transparent"
                }
              >
                <td className="py-2 px-4 border-r border-secondary/10 w-1/6 text-secondary/80 text-body1 ">
                  {formatDate(date)}
                </td>
                <td className="py-2 px-4 border-r border-secondary/10 w-1/6 text-secondary/80 text-body1">
                  {action}
                </td>
                <td className="py-2 px-4 border-r border-secondary/10 w-2/6 text-secondary/80 text-body1">
                  {remarks}
                </td>
                <td className="py-2 px-4 border-r border-secondary/10 w-1/6 text-secondary/80 text-body1">
                  {attempt}
                </td>
                <td className="py-2 px-4 border-r border-secondary/10 w-1/6 text-secondary/80 text-body1">
                  {by}
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default NdrHistory;
